/**
 * Shared query-key root for the BAMS (Blue Apron / Marley Spoon) pack line shorts
 * dashboard. Kept in its own file so every BAMS query hook derives its key from a
 * single source and a broad `invalidateQueries` can target the whole feature.
 */
export const BAMS_SHORTS_QUERY_KEY = 'bamsShorts';

/** Default cache tuning shared by the weekly (feed / sku / inventory) BAMS queries. */
export const BAMS_SHORTS_STALE_TIME = 2 * 60_000;
export const BAMS_SHORTS_GC_TIME = 10 * 60_000;
